
      import ArrowBack from './arrow-back.vue'
      import type { App, Plugin } from 'vue'

      export const ArrowBackPlugin: Plugin = {
        install(app: App) {
          app.component('ArrowBack', ArrowBack)
        },
      }
      export { ArrowBack }
      